import axios from 'axios'
import { getAPIService } from '../../getServerHost'
import { Id } from '../types'

export const getRcuDetail = async (id: Id) => {
  const response = await axios.get(`${getAPIService}/v2/api/rcus/${id}`)
  return response.data
}
